import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import GameCard from './GameCard'
import { useLottery } from 'state/lottery/hooks'
import { getBalanceNumber } from 'utils/formatBalance'
import { getLotteryMaxWinRate } from 'state/lottery/getLotteriesData'
import { getMaxPayout, getMaxWinRate } from 'state/predictions/helpers'
import { usePriceMjtUSDT } from 'state/hooks'
import { useTranslation } from 'react-i18next'
import BN from 'bignumber.js'

const Wrap = styled.div`
  width: 100%;
  position: relative;
  box-sizing: border-box;
  padding-bottom: 280px;
  @media (max-width: 768px) {
    padding-bottom: 100px;
  }
`

const Content = styled.div`
  margin: 0 auto;
  margin-top: 24px;
  width: 100%;
  max-width: 1200px;
  @media (max-width: 1200px) {
    padding: 0 24px;
  }
`

const Title = styled.div`
  font-family: 'SF Pro Rounded';
  font-style: normal;
  font-weight: 700;
  font-size: 32px;
  color: #01142a;
`

const ListWrap = styled.div`
  margin-top: 24px;
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  align-items: center;
  row-gap: 64px;
  column-gap: 24px;
  @media (max-width: 768px) {
    justify-content: center;
  }
`

const GameList: React.FunctionComponent = () => {
  const [lotteryRate, setLotteryRate] = useState('50')
  const [predictionPayOut, setPredictionPayOut] = useState(99)
  const [predictionRate, setPredictionRate] = useState('50')
  const { t } = useTranslation()
  const {
    currentRound: { amountCollectedInMjt },
  } = useLottery()
  const prizeInAmount = getBalanceNumber(amountCollectedInMjt)
  const mjtPrice = usePriceMjtUSDT()
  const prizeInUsdt = amountCollectedInMjt.times(mjtPrice).times(0.4)
  const prizeFirst = getBalanceNumber(prizeInUsdt)

  const getLotteryData = async () => {
    const data = await getLotteryMaxWinRate()
    setLotteryRate(data?.winRate ?? '50')
  }

  const getPredictionData = async () => {
    await Promise.all([getMaxPayout(), getMaxWinRate()]).then((res) => {
      setPredictionPayOut(res[0]?.maxPayout)
      setPredictionRate(res[1]?.winRate)
    })
  }

  useEffect(() => {
    getLotteryData()
    getPredictionData()
  }, [])

  return (
    <Wrap>
      <Content>
        <Title>{t('GAME_8')}</Title>
        <ListWrap>
          <GameCard
            id="card-img-lottery"
            title={t('GAME_1')}
            winRate={new BN(lotteryRate).toFixed(2, 1).toString()}
            multiple={Number(new BN(prizeFirst).toFixed(0, 1))}
            infoLeft={t('GAME_2')}
            infoRight={t('GAME_3')}
            showAmount={prizeInAmount}
            link="lottery"
          />
          <GameCard
            id="card-img-prediction"
            title={t('GAME_4')}
            winRate={new BN(predictionRate).toFixed(2, 1).toString()}
            multiple={Number(new BN(predictionPayOut).toFixed(0, 1))}
            infoRight={t('GAME_5')}
            link="prediction"
          />
        </ListWrap>
      </Content>
    </Wrap>
  )
}

export default GameList
